import { HttpErrorResponse } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { NotificationType } from 'angular2-notifications'
import { of } from 'rxjs'
import { catchError, map, switchMap, tap } from 'rxjs/operators'
import { LogService } from '../../services/log.service'
import { NotificationService } from '../../services/notification.service'
import * as WithPNOColleaguesActions from './with-pno-colleagues.actions'
import { WithPNOColleaguesService } from './with-pno-colleagues.service'

@Injectable()
export class WithPNOColleaguesEffects {
   private _cn = this.constructor.name
   private _actions$ = inject(Actions)
   private _logService = inject(LogService)
   private _notificationService = inject(NotificationService)
   private _withPNOColleaguesService = inject(WithPNOColleaguesService)

   getWithPNOColleaguesData$ = createEffect(() =>
      this._actions$.pipe(
         ofType(WithPNOColleaguesActions.getWithPNOColleaguesData),
         switchMap((action) =>
            this._withPNOColleaguesService.getWithPNOColleaguesData(action.request).pipe(
               tap((res) => this._logService.debug(this._cn, 'getWithPNOColleaguesData effect', 'response:', res)),
               map((WithPNOColleaguesItems) => WithPNOColleaguesActions.getWithPNOColleaguesDataSuccess({ data: WithPNOColleaguesItems })),
               catchError((error: HttpErrorResponse) => {
                  return of(WithPNOColleaguesActions.getWithPNOColleaguesDataFailure({ error: error }))
               })
            )
         )
      )
   )

   /* Notification error message */
   private _actionsForErrorNotificationMessage = [WithPNOColleaguesActions.getWithPNOColleaguesDataFailure]

   listenAllFailureAction$ = createEffect(
      () =>
         this._actions$.pipe(
            ofType(...this._actionsForErrorNotificationMessage),
            map((errorResponse) =>
               this._notificationService.notify(NotificationType.Error, undefined, `${errorResponse.error.status} - ${errorResponse.error.statusText}`)
            )
         ),
      { dispatch: false }
   )
}
